import { getFileSignedUrl } from "@/api";
import { downloadFromUrl } from "@/utils/downloadFile";

import type { UploadScope } from "@/components/tiptap/utils/uploadScope";
import type { ImageNodeAttrs } from "@corca/tiptap";

/**
 * Saves an uploaded image through a signed URL that forces a download, and an inline SVG from
 * its data URL. Any other `src` opens in a new tab, since browsers ignore `download` cross-origin.
 */
export async function downloadImage(
  scope: UploadScope | undefined,
  { key, src, name }: Pick<ImageNodeAttrs, "key" | "src" | "name">,
) {
  if (scope && key) {
    try {
      const { signedUrl, filename, contentType } = await getFileSignedUrl(
        scope.type,
        scope.uid,
        key,
        { download: true },
      );
      downloadFromUrl(signedUrl, name ?? filename, contentType);
    } catch (error) {
      console.error("Failed to download image", error);
    }
    return;
  }
  if (!src) return;

  const link = document.createElement("a");
  link.download = name ?? "";
  link.href = src;
  if (!src.startsWith("data:")) {
    link.target = "_blank";
    link.rel = "noopener noreferrer";
  }
  link.click();
}
